(() => {
  if (window.__RavinCollectionLayout2026) return;
  window.__RavinCollectionLayout2026 = true;
  const storageKey = 'ravin-pull-grid-columns';
  const mobile = window.matchMedia('(max-width: 749px)');
  const main = document.getElementById('MainContent');
  if (!main) return;
  const isArabic = () => (document.documentElement.lang || '').toLowerCase().startsWith('ar');
  const initial = () => {
    try { return window.localStorage.getItem(storageKey) === '2' ? 2 : 1; }
    catch (error) { return 1; }
  };
  let columns = initial();
  let widget = null;
  const updateButtons = () => {
    if (!widget) return;
    widget.querySelectorAll('[data-rvcol-view]').forEach(button => {
      button.setAttribute('aria-pressed', String(Number(button.dataset.rvcolView) === columns));
    });
  };
  const apply = (value, persist = true) => {
    columns = value === 2 ? 2 : 1;
    // Mobile-only preference: never override the desktop collection grid.
    main.classList.toggle('rvcol-view-one', mobile.matches && columns === 1);
    main.classList.toggle('rvcol-view-two', mobile.matches && columns === 2);
    main.classList.toggle('rpull-two', mobile.matches && columns === 2);
    updateButtons();
    if (persist) {
      try { window.localStorage.setItem(storageKey, String(columns)); } catch (error) {}
    }
  };
  const create = () => {
    const container = document.createElement('div');
    container.className = 'rvcol-view-switch';
    container.dataset.ravinCollectionLayout = '';
    container.setAttribute('role', 'group');
    container.setAttribute('aria-label', isArabic() ? 'عدد المنتجات في الصف' : 'Products per row');
    const label = document.createElement('span');
    label.className = 'rvcol-view-switch__label';
    label.textContent = isArabic() ? 'طريقة العرض' : 'VIEW / LAYOUT';
    const buttons = document.createElement('div');
    buttons.className = 'rvcol-view-switch__buttons';
    [1, 2].forEach(value => {
      const button = document.createElement('button');
      button.className = 'rvcol-view-switch__button';
      button.type = 'button';
      button.dataset.rvcolView = String(value);
      button.textContent = String(value).padStart(2, '0');
      button.setAttribute('aria-label', isArabic() ? (value === 1 ? 'منتج واحد في الصف' : 'منتجان في الصف') : (value === 1 ? 'One product per row' : 'Two products per row'));
      buttons.appendChild(button);
    });
    container.append(label, buttons);
    return container;
  };
  const target = () => main.querySelector('[data-ravin-results-root] [data-ravin-price-grid]') || main.querySelector('#ProductGridContainer');
  const ensure = () => {
    // On desktop the theme-defined grid (normally four columns) is authoritative.
    if (!mobile.matches) {
      if (widget && widget.isConnected) widget.remove();
      return;
    }
    const anchor = target();
    if (!anchor || !anchor.parentNode) return;
    if (!widget) widget = create();
    if (widget.nextElementSibling !== anchor || widget.parentNode !== anchor.parentNode) anchor.parentNode.insertBefore(widget, anchor);
    updateButtons();
  };
  main.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const local = event.target.closest('[data-rvcol-view]');
    if (local && widget?.contains(local)) {
      apply(Number(local.dataset.rvcolView));
      return;
    }
    const original = event.target.closest('[data-rpull-one],[data-rpull-two]');
    if (original) apply(original.matches('[data-rpull-two]') ? 2 : 1);
  });
  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      ensure();
    });
  };
  const observer = new MutationObserver(records => {
    const changed = records.some(record => [...record.addedNodes, ...record.removedNodes].some(node =>
      node === widget || (node.nodeType === 1 && (
        node.matches?.('[data-ravin-price-grid],#ProductGridContainer,[data-ravin-results-root]') ||
        node.querySelector?.('[data-ravin-price-grid],#ProductGridContainer,[data-ravin-results-root]')
      ))
    ));
    if (changed) schedule();
  });
  observer.observe(main, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', schedule);
  const onBreakpointChange = () => {
    apply(columns, false);
    schedule();
  };
  if (mobile.addEventListener) mobile.addEventListener('change', onBreakpointChange);
  else if (mobile.addListener) mobile.addListener(onBreakpointChange);
  window.addEventListener('popstate', schedule);
  apply(columns, false);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ensure, { once: true });
  else ensure();
})();
